import { render } from "./ClientsTable.vue?vue&type=template&id=191dab0e&scoped=true&lang=pug"
import script from "./ClientsTable.vue?vue&type=script&lang=ts"
export * from "./ClientsTable.vue?vue&type=script&lang=ts"

import "./ClientsTable.vue?vue&type=style&index=0&id=191dab0e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-191dab0e"

export default script